import { call, takeLeading } from 'redux-saga/effects';

import { environment } from '../../environment';
import { putEffect } from '../../shared/utils/putEffect';
import {
	readUserRolesFulfilled,
	readUserRolesRejected,
	resetPasswordAction,
	loginUser,
	signUpUser,
	readUserRoles,
	logoutUser,
} from './actions';
import {
	LOGIN_USER,
	LoginUser,
	SignUpUser,
	SIGN_UP_USER,
	ResetPasswordAction,
	RESET_PASSWORD,
	GET_USER_ROLES,
	LOGOUT_USER,
} from './types';
import { routePaths } from '../../shared/consts/routePaths';
import { getApiError } from '../../shared/utils/getApiError';
import { createRouteFromBlueprint } from '../../shared/utils/routeMatcher';
import { toSentence } from '../../shared/utils/camelize';
import { pend, fulfill, reject } from '../promise/actions';
import axios from '@utils/axios';
export const meEndPoint = `profiles/me`;
export const loginEndpoint = `auth/login`;
export const signoutEndpoint = `auth/signout`;
export const signInEndPoint = `auth/register`;
export const resetPassEndpoint = `auth/reset-password`;
export const rolesEndPoint = `roles/me`;

const getUserRolesRequest = () => {
	return axios.get(`${environment.apiUrl}${rolesEndPoint}`);
};

function* loginUserSaga(action: LoginUser) {
	try {
		yield putEffect(pend(loginUser));
		yield axios.post(`${environment.apiUrl}${loginEndpoint}`, action.payload);
		yield putEffect(readUserRoles());
		setTimeout(() => {
			window.location.href = createRouteFromBlueprint(routePaths.home.root)({});
		}, 0);

		yield putEffect(fulfill(loginUser, action.payload));
	} catch (e) {
		yield putEffect(reject(loginUser, toSentence(getApiError(e))));
	}
}

function* signUpUserSaga(action: SignUpUser) {
	try {
		yield putEffect(pend(signUpUser));
		yield axios.post(`${environment.apiUrl}${signInEndPoint}`, {
			...action.payload,
			rememberUser: true,
			productUrl: window.location.origin,
		});
		setTimeout(() => {
			window.location.href = createRouteFromBlueprint(routePaths.home.root)({});
		}, 0);
		yield putEffect(fulfill(signUpUser, action.payload));
	} catch (e) {
		yield putEffect(reject(signUpUser, toSentence(getApiError(e))));
	}
}

function* resetPassword(action: ResetPasswordAction) {
	try {
		yield putEffect(pend(resetPasswordAction));
		yield axios.post(`${environment.apiUrl}${resetPassEndpoint}`, {
			...action.payload,
			productUrl: window.location.origin,
		});
		yield putEffect(fulfill(resetPasswordAction, action.payload));
	} catch (e) {
		yield putEffect(reject(resetPasswordAction, getApiError(e)));
	}
}

export function* readUserRolesSaga() {
	try {
		yield putEffect(pend(readUserRoles));
		const rolePermissions = yield call(getUserRolesRequest);
		yield putEffect(readUserRolesFulfilled(rolePermissions.data));
		yield putEffect(fulfill(readUserRoles));
	} catch (e) {
		yield putEffect(readUserRolesRejected(e as Error));
		yield putEffect(fulfill(readUserRoles));
	}
}

function* logoutSaga() {
	try {
		yield putEffect(pend(logoutUser));
		yield axios.post(`${environment.apiUrl}${signoutEndpoint}`);
		yield putEffect(fulfill(logoutUser));
	} catch (e) {
		yield putEffect(reject(logoutUser, getApiError(e)));
	}
}

export const userSagas = [
	function* getLoginWatcher() {
		yield takeLeading(LOGIN_USER, loginUserSaga);
	},

	function* getSignUpWatcher() {
		yield takeLeading(SIGN_UP_USER, signUpUserSaga);
	},

	function* getResetPassWatcher() {
		yield takeLeading(RESET_PASSWORD, resetPassword);
	},

	function* getUserRolesWatcher() {
		yield takeLeading(GET_USER_ROLES, readUserRolesSaga);
	},
	function* logoutUserWatcher() {
		yield takeLeading(LOGOUT_USER, logoutSaga);
	},
];
